<template>
  <CustomDatePicker
    :inputId="inputId"
    :inputLabel="inputLabel"
    :initialValue="initialValue"
    :isFormField="isFormField"
    :isMandatory="isMandatory"
    :minDate="minDate"
    :maxDate="maxDate"
    :isSmall="isSmall"
    :isDisabled="isDisabled"
    dateType="month"
    valueFormat="YYYY-MM"
    displayFormat="MMM YYYY"
    @onChange="onChange"
  />
</template>

<script lang="ts">
import CustomDatePicker from "@/components/input/CustomDatePicker.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "CustomMonthPicker",
  components: { CustomDatePicker },
  props: {
    inputId: { type: String, required: true },
    initialValue: { type: String, default: null },
    isFormField: { type: Boolean, default: false },
    inputLabel: { type: String },
    isMandatory: { type: Boolean, default: false },
    minDate: { type: Date },
    maxDate: { type: Date },
    isSmall: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    function onChange(date: string) {
      emit("onChange", date);
    }
    return { onChange };
  },
});
</script>
